export const WEBHOOK = "WEBHOOK"
export const WEBHOOK_SUCCESS = `${WEBHOOK}_SUCCESS`
export const WEBHOOK_FAILURE = `${WEBHOOK}_FAILURE`
export const WEBHOOK_CALL = `${WEBHOOK}_CALL`

export const WEBHOOK_FORM = "WEBHOOK_FORM"
export const WEBHOOK_FORM_SUCCESS = `${WEBHOOK_FORM}_SUCCESS`
export const WEBHOOK_FORM_FAILURE = `${WEBHOOK_FORM}_FAILURE`
export const WEBHOOK_FORM_CALL = `${WEBHOOK_FORM}_CALL`
